import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { getCategoryName } from '@/lib/queries';

type MovieCardProps = {
  movie: Movie;
  rank?: number;
};

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link to={`/detail/${movie.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg border border-background-800 bg-background-900">
        <img
          src={movie.cover}
          alt={`${movie.title} 影片封面`}
          title={`${movie.title} - 日韩成人电影`}
          className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.06]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/25 to-transparent" />

        <div className="absolute top-2.5 left-2.5 flex items-center gap-1 rounded-md bg-background-950/80 px-2 py-1 backdrop-blur-sm">
          <i className="ri-star-fill text-accent-500 text-xs" />
          <span className="font-label text-xs font-semibold tracking-wide text-accent-300">{movie.rating.toFixed(1)}</span>
        </div>

        <div className="absolute top-2.5 right-2.5 rounded-md bg-primary-600/90 px-2 py-1 text-[11px] font-medium tracking-wide text-background-50">
          {movie.region}
        </div>

        {typeof rank === 'number' && (
          <div className="absolute bottom-2.5 left-2.5 font-label text-3xl font-bold leading-none text-background-50/95">
            {String(rank).padStart(2, '0')}
          </div>
        )}

        <div className="absolute inset-x-0 bottom-0 p-3">
          <div className="flex flex-wrap items-center gap-1.5 text-[11px] text-foreground-300">
            <span className="rounded bg-background-800/80 px-1.5 py-0.5">{getCategoryName(movie.category)}</span>
            <span className="font-label tracking-wide">{movie.year}</span>
            <span className="font-label tracking-wide">{movie.duration} 分钟</span>
          </div>
        </div>
      </div>

      <h3 className="mt-3 text-sm md:text-[15px] font-semibold text-foreground-100 transition-colors group-hover:text-accent-400 line-clamp-1">
        {movie.title}
      </h3>
      <p className="mt-1 font-label text-[11px] uppercase tracking-[0.12em] text-foreground-600 line-clamp-1">
        {movie.englishTitle}
      </p>
      <p className="mt-1.5 text-xs leading-relaxed text-foreground-500 line-clamp-2">{movie.summary}</p>
    </Link>
  );
}